"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function usePrevious(value, initialValue) {
    var ref = React.useRef(initialValue);
    React.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
exports.default = usePrevious;
//# sourceMappingURL=usePrevious.js.map